"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulletIcon = void 0;
var react_1 = __importDefault(require("react"));
var colors_1 = require("../../../themes/colors");
var DisplayIcon_1 = require("../../../../utils/comps/DisplayIcon");
var black = colors_1.colors.black;
var BulletIcon = function () { return (
// line height of SANS_3 is 21px. Dot is 8px tall. so below css (21/2 - 8/2) makes the circle perfectly aligned with the first line
react_1.default.createElement("div", { style: { fontSize: 0, marginTop: '6.5px', lineHeight: 0 } },
    react_1.default.createElement(DisplayIcon_1.DisplayIcon, { color: black, weight: "fill", icon: "Circle", size: 8 }))); };
exports.BulletIcon = BulletIcon;
